import { v4 as uuid } from "uuid";
import FileAPI from "@/api/FileAPI";

import { createSlice, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import {FILES, DOCUMENT, SETTINGS} from "@/actions/globalConst";

export const initialState = {
    userDocuments: [],
    selected: null,
    api_state: DOCUMENT.API_INIT,
};

const DocumentReducer = createSlice({
  name: 'document',
  initialState,
  reducers: {
        setSelectedMap(state, action) {
            if(action.payload?.selected) {
                state.selected = action.payload.selected;
            }
    },

    // omit existing reducers here
  },
  extraReducers(builder) {
      builder.addCase(uploadDocument.fulfilled, (state, action) => {
        state.api_state = FILES.API_READY;
        if(action.payload.data.data) {
            state.userDocuments = action.payload.data.data;
        }
          
      }).addCase(uploadDocument.rejected, (state, action) => {
          //    state.api_state = SETTINGS.API_E;
      }).addCase(uploadDocument.pending,(state, action) => {
        state.api_state = FILES.API_PENDING;
      });
      
      builder.addCase(getUserDocuments.fulfilled, (state, action) => {
        state.api_state = FILES.API_READY;
        if(action.payload.data.data) {
            state.userDocuments = action.payload.data.data;
        }
          
      }).addCase(getUserDocuments.rejected, (state, action) => {
          //    state.api_state = SETTINGS.API_E;
      }).addCase(getUserDocuments.pending,(state, action) => {
        state.api_state = FILES.API_PENDING;
      });

      builder.addCase(removeDocument.fulfilled, (state, action) => {
        state.api_state = FILES.API_READY;
        if(action.payload.data.data) {
            state.userDocuments = action.payload.data.data;
        }
          
      }).addCase(removeDocument.rejected, (state, action) => {
          //    state.api_state = SETTINGS.API_E;
      }).addCase(removeDocument.pending,(state, action) => {
        state.api_state = FILES.API_PENDING;
      });
      
  }
});

export const getUserDocuments = createAsyncThunk(
  DOCUMENT.GET_USER_DOCS,
  async (data, event) => {
    let response = null;
    try {
          response = await FileAPI.getUserDocuments(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)


export const uploadDocument = createAsyncThunk(
  DOCUMENT.NEW,
  async (data:any = null, event) => {
    let response = null;
    try {
          response = await FileAPI.storeDocument(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const removeDocument = createAsyncThunk(
  DOCUMENT.DELETE,
  async (data:any = null, event) => {
    let response = null;
    try {
          response = await FileAPI.deleteDocument(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)


//export const getInvoiceAPIState = (state) => state.invoice;;
//export const { setSelectedMap } = FilesReducer.actions;
export default DocumentReducer.reducer